import { Box, Typography } from "@mui/material";
import { OLButton } from "OLButton";
import { ReactComponent as SearchSmIcon } from "components/Icons/search-sm.svg";
import { useMessage } from "hooks/intl";
import { useNavigate } from "react-router-dom";
import { links } from "utilities/links";
import { useStyles } from "./AchievementTemplates.styles";

export const EmptySearchView = () => {
  const classes = useStyles();
  const { message } = useMessage();
  const navigate = useNavigate();

  return (
    <Box className={classes.emptyStateContainer}>
      <Box className={classes.iconWrapper}>
        <SearchSmIcon className={classes.icon} />
      </Box>
      <Typography className={classes.emptyStateTitle}>
        {message({ id: "noResultsFound" })}
      </Typography>
      <Typography className={classes.emptyStateSubtitle}>
        {message({ id: "adjustSearchCriteriaToFindTemplate" })}
      </Typography>
      <OLButton
        variant="contained"
        onClick={() => navigate(links.addAchievement)}
        data-test-id="start-from-scratch"
      >
        {message({ id: "startFromScratch" })}
      </OLButton>
    </Box>
  );
};
